import { Link } from 'react-router-dom';

const LODGING_TYPES = [
  {
    icon: 'ri-home-5-line',
    label: 'Luxury Cabins',
    desc: 'Upscale mountain retreats with premium amenities, private settings, and high guest ratings.',
    link: '/best-luxury-cabins',
  },
  {
    icon: 'ri-building-line',
    label: 'Vacation Rentals',
    desc: 'A wide range of vacation rentals in Highlands, NC — from cozy cottages to spacious mountain homes.',
    link: '/cabins-in-highlands-nc',
  },
  {
    icon: 'ri-water-flash-line',
    label: 'Near Waterfalls',
    desc: 'Cabins within walking distance of Glen Falls and other scenic waterfalls on the Highlands plateau.',
    link: '/cabins-near-glen-falls-highlands-nc',
  },
  {
    icon: 'ri-footprint-line',
    label: 'Pet-Friendly Stays',
    desc: 'Dog-friendly cabins in Highlands, North Carolina with easy access to trails and outdoor spaces.',
    link: '/pet-friendly-cabins-highlands-nc',
  },
];

export default function BestPlacesSection() {
  return (
    <section className="w-full bg-white py-20 px-6 lg:px-14 border-b border-[#EDE8E0]">
      <div className="max-w-5xl mx-auto">

        {/* Headline */}
        <div className="text-center mb-10">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost font-light mb-5">
            / Lodging Guide
          </p>
          <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light leading-tight mb-7">
            Best Places to Stay<br />
            <em className="italic font-light">in Highlands, NC</em>
          </h2>
          <div className="w-10 h-px bg-[#C9A96E] mx-auto mb-8" />

          {/* Intro paragraph */}
          <p className="text-[#5C5850] font-jost text-base leading-relaxed max-w-3xl mx-auto mb-5">
            Highlands, North Carolina offers a variety of <strong className="text-[#2D4A3E] font-medium">places to stay in Highlands, NC</strong> — including luxury cabins, vacation rentals, and mountain homes spread across the plateau. This site curates some of the best options to help travelers find the right place to stay, based on guest ratings, location, and what actually matters when you&apos;re planning a trip.
          </p>
          <p className="text-[#5C5850] font-jost text-base leading-relaxed max-w-3xl mx-auto">
            Whether you&apos;re looking for a secluded retreat near a waterfall, a pet-friendly stay close to hiking trails, or a comfortable base near downtown, the guides below cover the most recommended <strong className="text-[#2D4A3E] font-medium">vacation rentals in Highlands, NC</strong> and <strong className="text-[#2D4A3E] font-medium">cabins in Highlands, North Carolina</strong> — organized by what travelers actually search for.
          </p>
        </div>

        {/* Lodging type cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {LODGING_TYPES.map((type) => (
            <Link
              key={type.label}
              to={type.link}
              className="group flex flex-col items-start p-6 rounded-xl border border-[#EDE8E0] hover:border-[#2D4A3E]/30 hover:bg-[#FAFAF8] transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EDE8E0] group-hover:bg-[#2D4A3E]/10 transition-colors mb-4">
                <i className={`${type.icon} text-[#2D4A3E] text-base`} />
              </div>
              <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium leading-snug mb-2">
                {type.label}
              </h3>
              <p className="text-[#5C5850] font-jost text-xs leading-relaxed flex-1 mb-4">
                {type.desc}
              </p>
              <span className="inline-flex items-center gap-1.5 text-[#2D4A3E] text-xs font-jost font-medium group-hover:gap-2.5 transition-all">
                Explore
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs" />
                </div>
              </span>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}
